export default __webpack_public_path__ + "media/Gytpol.560de8aa.webp";